module.exports = __webpack_public_path__ + "static/media/map-bg.6e682f8d.png";